import React from 'react'
import { connect } from 'react-redux'
import SectionActions from '../../Redux/SectionRedux'

class UpdateSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        title_id: props.detail.title_id || '',
        title_en: props.detail.title_en || '',
        subtitle: props.detail.subtitle || '',
        description: props.detail.description || ''
      }
    }
  }

  _inputChange = (e, f) => {
    if (e) e.preventDefault()
    let v = e.target.value
    let form = { ...this.state.form }
    form[f] = v
    this.setState({ form })
  }

  _submit = (e) => {
    if (e) e.preventDefault()
    let form = { ...this.state.form }
    let uuid = this.props.detail.id
    let data = { uuid, form }
    this.props.putSubSection(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 500)
  }

  render () {
    return (
      <section style={{ width: '40vw' }}>
        <div className='title-block'>
          <h3 className='title'>Edit Subsection</h3>
        </div>
        <form onSubmit={(e) => this._submit(e)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title (ID)</label>
            </div>
            <div className='col-9'>
              <input required value={this.state.form.title_id} className='form-control' placeholder='Input Title (ID)' onChange={(e) => this._inputChange(e, 'title_id')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title (EN)</label>
            </div>
            <div className='col-9'>
              <input required value={this.state.form.title_en} className='form-control' placeholder='Input Title (EN)' onChange={(e) => this._inputChange(e, 'title_en')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Subtitle</label>
            </div>
            <div className='col-9'>
              <input value={this.state.form.subtitle} className='form-control' placeholder='Input Subtitle' onChange={(e) => this._inputChange(e, 'subtitle')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Description</label>
            </div>
            <div className='col-9'>
              <textarea rows='5' cols='50' value={this.state.form.description} className='form-control' onChange={(e) => this._inputChange(e, 'description')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
              <button type='submit' className='btn btn-primary'>Submit</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  section: state.section
})

const dispatchToProps = (dispatch) => ({
  putSubSection: (data) => dispatch(SectionActions.putSubSectionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateSection)



// WEBPACK FOOTER //
// ./src/Containers/Section/UpdateSubSection.js